import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const marketplaceUrl = new URL(process.env.REACT_APP_MARKETPLACE_URL);
if (marketplaceUrl.protocol !== 'https:') {
  throw new Error('REACT_APP_MARKETPLACE_URL must be an HTTPS address.');
}

export const MarketplaceLink = ({ id, showDomain = false, onClick }) => (
  <a
    className="marketplace-domain-link"
    data-testid={id}
    href={marketplaceUrl.href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`B2B bulk buying and selling at ${marketplaceUrl.hostname} (opens in a new tab)`}
    title={`B2B bulk buying and selling · ${marketplaceUrl.hostname}`}
    onClick={onClick}
  >
    {showDomain ? `${marketplaceUrl.hostname} · B2B marketplace` : 'Bulk buying & selling'}
    <ArrowUpRight size={14} aria-hidden="true" />
  </a>
);